import {
  Parameter,
  BurialSocietyFileType
} from '@ecosure-suite/shared/utils-helpers';

export interface Document {
  id: number;
  type: BurialSocietyFileType;
  owner: Parameter;
  ext?: string;
  format?: string;
  uri?: string;
  dateCreated?: Date;
}

export class DocumentForm {
  owner: Parameter;
  document?: Document;
  type: BurialSocietyFileType;
  file: File;
}
